import DashBoardStatCard from '@/pages/agentDashboard/components/DashBoardStatCard/DashBoardStatCard';
import React from 'react';
import useGetAgentRakeStats from '@/services/rake/queries/useGetAgentRakeStats';
import useIsMobileView from '@/hooks/useIsMobileView';
import usePhnmPrice from '@/hooks/usePhnmPrice';

const AgentCardsSection = () => {
  const { data: phnmPrice, isLoading: isLoadingPhnmPrice } = usePhnmPrice();
  const { data: rakeStatsData, isLoading: isLoadingRakeStats } = useGetAgentRakeStats();
  const isMobileView = useIsMobileView();

  if (isMobileView) {
    return (
      <section className="flex flex-col gap-2">
        <div className="flex gap-2">
          <DashBoardStatCard
            title="Last 24 Hours"
            total={rakeStatsData?.data.dayRevenue.current}
            showIcon
            isLoading={isLoadingRakeStats}
            useGreyIcon
          />
          <DashBoardStatCard
            title="Last 7 Days"
            total={rakeStatsData?.data.weekRevenue.current}
            showIcon
            isLoading={isLoadingRakeStats}
            useGreyIcon
          />
          <DashBoardStatCard
            title="Last 365 Days"
            total={rakeStatsData?.data.yearRevenue.current}
            showIcon
            isLoading={isLoadingRakeStats}
            useGreyIcon
          />
        </div>
        <div className="flex gap-2">
          <DashBoardStatCard
            usePhenomIcon
            title="Total Tokens Earned"
            total={rakeStatsData?.data.totalTokensEarned}
            isLoading={isLoadingRakeStats}
          />
          <DashBoardStatCard
            title="Total Referrals"
            total={rakeStatsData?.data.totalReferrals}
            isLoading={isLoadingRakeStats}
          />
          <DashBoardStatCard
            title="Playing Now"
            total={rakeStatsData?.data.activeReferrals}
            isLoading={isLoadingRakeStats}
          />
        </div>
      </section>
    );
  }

  return (
    <section className="flex gap-4">
      <DashBoardStatCard
        title="Token Value"
        total={
          rakeStatsData?.data.totalTokensEarned
            ? rakeStatsData?.data.totalTokensEarned * Number(phnmPrice.displayPrice)
            : 0
        }
        showIcon
        isLoading={isLoadingRakeStats || isLoadingPhnmPrice}
      />
      <DashBoardStatCard title="Token Price" total={phnmPrice.displayPrice} showIcon isLoading={isLoadingPhnmPrice} />
      <DashBoardStatCard
        title="Total Referrals"
        total={rakeStatsData?.data.totalReferrals}
        isLoading={isLoadingRakeStats}
      />
      <DashBoardStatCard
        title="Playing Now"
        total={rakeStatsData?.data.activeReferrals}
        isLoading={isLoadingRakeStats}
      />
    </section>
  );
};

export default AgentCardsSection;
